var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1016)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5239 1.28564C15.1287 1.28564 15.6191 1.776 15.6191 2.38088V15.5237C15.6191 16.1286 15.1287 16.619 14.5239 16.619H1.381C0.776121 16.619 0.285767 16.1286 0.285767 15.5237V2.38088C0.285767 1.776 0.776121 1.28564 1.381 1.28564H14.5239ZM14.5239 2.38088H1.381V15.5237H14.5239V2.38088ZM9.04767 11.1428V12.238H2.47624V11.1428H9.04767ZM13.4286 8.95231V10.0475H2.47624V8.95231H13.4286ZM13.4286 6.76184V7.85707H2.47624V6.76184H13.4286ZM13.4286 4.57136V5.6666H2.47624V4.57136H13.4286Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_20_1016",
    maskUnits: "userSpaceOnUse",
    x: 10.4728,
    y: 8.26538,
    width: 10,
    height: 11,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.4728,
    y: 8.26538,
    width: 10,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7168 13.5095C17.3911 13.5095 18.7483 14.8667 18.7483 16.5409V17.7535H11.4728V16.5409C11.4728 14.8667 12.83 13.5095 14.5042 13.5095H15.7168ZM15.1105 9.26538C16.1151 9.26538 16.9294 10.0797 16.9294 11.0843C16.9294 12.0888 16.1151 12.9031 15.1105 12.9031C14.106 12.9031 13.2917 12.0888 13.2917 11.0843C13.2917 10.0797 14.106 9.26538 15.1105 9.26538Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7168 13.5095C17.3911 13.5095 18.7483 14.8667 18.7483 16.5409V17.7535H11.4728V16.5409C11.4728 14.8667 12.83 13.5095 14.5042 13.5095H15.7168ZM15.1105 9.26538C16.1151 9.26538 16.9294 10.0797 16.9294 11.0843C16.9294 12.0888 16.1151 12.9031 15.1105 12.9031C14.106 12.9031 13.2917 12.0888 13.2917 11.0843C13.2917 10.0797 14.106 9.26538 15.1105 9.26538Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7483 17.7535V18.7535H19.7483V17.7535H18.7483ZM11.4728 17.7535H10.4728V18.7535H11.4728V17.7535ZM15.7168 14.5095C16.8388 14.5095 17.7483 15.419 17.7483 16.5409H19.7483C19.7483 14.3144 17.9433 12.5095 15.7168 12.5095V14.5095ZM17.7483 16.5409V17.7535H19.7483V16.5409H17.7483ZM18.7483 16.7535H11.4728V18.7535H18.7483V16.7535ZM12.4728 17.7535V16.5409H10.4728V17.7535H12.4728ZM12.4728 16.5409C12.4728 15.419 13.3823 14.5095 14.5042 14.5095V12.5095C12.2777 12.5095 10.4728 14.3144 10.4728 16.5409H12.4728ZM14.5042 14.5095H15.7168V12.5095H14.5042V14.5095ZM15.1105 10.2654C15.5628 10.2654 15.9294 10.632 15.9294 11.0843H17.9294C17.9294 9.52744 16.6674 8.26538 15.1105 8.26538V10.2654ZM15.9294 11.0843C15.9294 11.5365 15.5628 11.9031 15.1105 11.9031V13.9031C16.6674 13.9031 17.9294 12.6411 17.9294 11.0843H15.9294ZM15.1105 11.9031C14.6583 11.9031 14.2917 11.5365 14.2917 11.0843H12.2917C12.2917 12.6411 13.5537 13.9031 15.1105 13.9031V11.9031ZM14.2917 11.0843C14.2917 10.632 14.6583 10.2654 15.1105 10.2654V8.26538C13.5537 8.26538 12.2917 9.52744 12.2917 11.0843H14.2917Z",
    fill: "white",
    mask: "url(#path-2-outside-1_20_1016)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.43c9bfd2.svg";
export { ForwardRef as ReactComponent };